import React from 'react'
import { OptionWrapper } from 'src/editor/layout/sidebar/settings/option-wrapper'
import { CheckboxNew } from 'src/editor/shared/ui-lib/checkbox-new'

type ChoiceValue = number | string

type Choice<T extends ChoiceValue> = {
  label: string
  value: T
}

type ChoicesProps<T extends ChoiceValue> = {
  values: T[]
  choices: Choice<T>[]
  label?: string
  update: (values: T[]) => void
}

function Choices<T extends ChoiceValue>({
  values,
  update,
  choices,
  label,
}: ChoicesProps<T>) {
  function handleUpdate(updatedValue: T) {
    return (checked: boolean) => {
      if (checked) {
        update([...values, updatedValue])
      } else {
        update(values.filter(value => updatedValue !== value))
      }
    }
  }

  return (
    <OptionWrapper labelText={label}>
      {choices.map(choice => (
        <CheckboxNew
          key={choice.value}
          label={choice.label}
          skipTranslation
          onChange={handleUpdate(choice.value)}
          checked={values.includes(choice.value)}
          wrapperClassName="mr-2"
        />
      ))}
    </OptionWrapper>
  )
}

export default Choices
